exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".curriculumDocumentsTable---3sFPl .root---2yGL9{width:100%;overflow-x:auto}.curriculumDocumentsTable---3sFPl .root---2yGL9 .table---13oVT{min-width:700px;font-family:Poppins,sans-serif}.curriculumDocumentsTable---3sFPl .root---2yGL9 .table---13oVT .documentColumn---r0uDn{display:-webkit-box;display:-moz-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;-moz-align-items:center;align-items:center}.curriculumDocumentsTable---3sFPl .root---2yGL9 .table---13oVT .documentColumn---r0uDn .documentButton---37NUK{margin:0 10px;height:20px}", ""]);

// exports
exports.locals = {
	"curriculumDocumentsTable": "curriculumDocumentsTable---3sFPl",
	"root": "root---2yGL9",
	"table": "table---13oVT",
	"documentColumn": "documentColumn---r0uDn",
	"documentButton": "documentButton---37NUK"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader/dist/cjs.js?{"implementation":{"info":"dart-sass/t1.26.11/t(Sass Compiler)/t[Dart]/ndart2js/t2.9.3/t(Dart Compiler)/t[Dart]","types":{},"NULL":{},"TRUE":{"value":true},"FALSE":{"value":false}},"includePaths":["/usr/src/app/node_modules"]}!./app/components/curriculum-documents/display-table/index.scss
// module id = 751
// module chunks = 3